import { render } from "./DashboardAntragErstellen.pug?vue&type=template&id=6c1a3067&lang=pug"
import script from "./DashboardAntragErstellen.js?vue&type=script&lang=js"
export * from "./DashboardAntragErstellen.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__